import ProductClassItem from "../common/items/ProductClassItem";

export default props=> {
    if (!props.me) return <></>;

    const productClasses = [
        {
            url: "www.naver.com",
            brand: { name: "NAVER" },
            category: {
                name: "CLOTH",
                id: "44"
            },
        },
        {
            brand: { name: "NAVER2" },
            category: {
                name: "CLOTH2",
                id: "37"
            },
        },

        {
            brand: { name: "CHANEL" },
            category: {
                name: "CARDIGAN",
                id: "37"
            },
        },

        {
            brand: { name: "GAP" },
            category: {
                name: "COAT",
                id: "39"
            },
        },
        {
            brand: { name: "CONVERSE" },
            category: {
                name: "SNEAKERS",
                id: "4"
            },
        },
    ];

    const jsx= (<div className="this-content">
    <style jsx>{`
.this-content{
    width: 300px;
    padding: 20px 0;
}

@media all and (max-width:606px) {
    .this-content{
        width: 100%;
    }
}


`}</style>
{props.me.map((v,i,a)=>
    <ProductClassItem key={i}
        isHighlighted={v.url ? "highlighted" : ""} 
        url={v.url}
        imgSrc={"cate-" + v.category.id + "-" + (v.url ? "p" : "n") + ".png"} 
        className={v.category.name} 
        brandName={v.brand.name} 
    />
)}
</div>);
return (jsx);
};
